import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { setTech, viewTech } from '../../modules/techModule/tech';
import { viewTechPlan } from '../../modules/techModule/techPlan';
import { viewTechRslt } from '../../modules/techModule/techRslt';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import TechStepperTemplate from '../../components/techSupports/TechStepperTemplate';
import TechTemplate from '../../components/techSupports/TechTemplate';
import * as techApi from '../../lib/api/tech';
import moment from 'moment';
import { listMidTechs } from '../../modules/techModule/techMids';

const ReqTechStepperContainer = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [titleData, setTitleData] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  const { tech, techPlan, techMids, techMidInfo, techRslt, project, user, error, loading } = useSelector(
    ({ techModule, auth, loading }) => ({
      user: auth.user,
      tech: techModule.tech.tech,
      techPlan: techModule.techPlan.techPlan,
      techMids: techModule.midTechs.techMids,
      techMidInfo: techModule.midTechs.techMidInfo,
      techRslt: techModule.techRslt.techRslt,
      project: techModule.tech.project,
      error: techModule.tech.error,
      loading: loading['tech/VIEW_TECH'],
    }),
  );

  useEffect(() => {
    dispatch(viewTech(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (tech) {
      const step = parseInt(tech.reqGrade) - 1;
      const tab = getActiveTap(tech.reqGrade);
      setActiveStep(step);
      setActiveTab(tab);
    }
  }, [tech])

  const checkMidTab = (techPlan) => {
    return techPlan?.plnTyp.includes('장기') ? 2 : 3;
  }

  const getActiveTap = (grade) => {
    let tab = 0
    if (grade === "1") {
      tab = 0;
    } else if (grade === "2") {//지원확인
      tab = 1;
    } else if (grade === "3") {//작업계획
      tab = checkMidTab(techPlan);

    } else if (grade > 3) {
      tab = 3;
    }
    return tab;
  }


  useEffect(() => {
    if (tech && tech?.planUuid !== null && tech?.planUuid !== '') {
      dispatch(viewTechPlan(tech.planUuid));
      const searchData = { "reqUuid": tech?.reqUuid, "planUuid": tech?.planUuid, "prjUuid": tech?.prjUuid };
      dispatch(listMidTechs(searchData));
    }
  }, [tech]);

  useEffect(() => {
    if (tech && tech?.rsltUuid !== null && tech?.rsltUuid !== '') {
      dispatch(viewTechRslt(tech.rsltUuid));
    }
  }, [tech])




  useEffect(() => {
    if (tech) {
      let title = {
        name: tech.reqStatus + ' [' + tech.reqNo + '] ',
        no: tech.reqNo,
      };
      setTitleData(title);

    }
  }, [tech]);

  const handleGoBack = () => {
    navigate('/reqtechmng');
  };

  const handleEdit = () => {
    navigate(`/reqtechmng/${id}/edit`);
  };

  const handleTabChange = (event, newValue) => {
    // console.log(newValue, 'newValue')
    // let newStep = newValue;
    setActiveTab(newValue)
  }


  const reloadTech = async (id) => {

    try {
      const res = await techApi.getTechById(id);
      if (res.data.info) {
        dispatch(setTech(res.data.info));
      }
    } catch (err) {
      console.log(err)
    }
  }


  if (!project || !tech) {
    return null;
  }




  return (
    <TechTemplate tech={tech} loading={loading} error={error}>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="기술지원/작업 지원 요청 관리/상세보기"
        menuLink="/reqtechmng"
        icon="tech"
        titleData={titleData}
        handleEdit={handleEdit}
      />

      <TechStepperTemplate
        activeStep={activeStep}
        activeTab={activeTab}
        tech={tech}
        techRslt={techRslt}
        techPlan={techPlan}
        techMids={techMids}
        techMidInfo={techMidInfo}
        project={project}
        user={user}
        reloadTech={reloadTech}
        handleTabChange={handleTabChange}
      />

    </TechTemplate>
  )
}

export default ReqTechStepperContainer